import React from 'react';
import PropTypes from 'prop-types';

import CardsContainer from '../../../../containers/CardsContainer';
import CardsStackedVerticalQuarterMarkup from './CardsStackedVerticalQuarter';

const CardsStackedVerticalQuarter = ({
  contentBoxAlignmentDefault,
  contentBoxAlignmentOverridesByIndex,
  ...props
}) => (
  <CardsContainer
    childComponent={CardsStackedVerticalQuarterMarkup}
    contentBoxAlignmentDefault={contentBoxAlignmentDefault}
    contentBoxAlignmentOverridesByIndex={contentBoxAlignmentOverridesByIndex}
    {...props}
  />
);

CardsStackedVerticalQuarter.defaultProps = {
  contentBoxAlignmentDefault: 'bottom',
  contentBoxAlignmentOverridesByIndex: [
    { index: 1, value: 'top' },
    { index: 3, value: 'top' },
  ],
};

CardsStackedVerticalQuarter.propTypes = {
  contentBoxAlignmentDefault: PropTypes.oneOf(['bottom', 'top']),
  contentBoxAlignmentOverridesByIndex: PropTypes.arrayOf(PropTypes.shape({
    index: PropTypes.number.isRequired,
    value: PropTypes.oneOf(['bottom', 'top']).isRequired,
  })),
};

export default CardsStackedVerticalQuarter;
